import React, { useRef } from "react";
import { Search, X } from "lucide-react";

function PanelUserSearch({ value, onChange }) {
  const inputRef = useRef(null);

  const handleClear = () => {
    onChange("");
    inputRef.current?.focus(); // ✅ keep cursor inside after clear
  };

  return (
    <div className="w-full flex justify-center mb-6 px-2">
      <div className="w-full max-w-xl flex items-center bg-white border border-gray-200 rounded-xl px-4 py-2 shadow-sm  transition">

        {/* 🔍 Search Icon */}
        <Search className="text-gray-400 mr-2" size={18} />

        {/* Input */}
        <input
          ref={inputRef}
          type="text"
          placeholder="Search users..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400"
        />

        {/* ❌ Clear Button */}
        {value && (
          <X
            size={16}
            onClick={handleClear}
            className="ml-2 cursor-pointer text-gray-400 hover:text-black transition"
          />
        )}
      </div>
    </div>
  );
}

export default PanelUserSearch;